import React from 'react'

const SliceIcon = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
    <path d="M15.544 8.65c-.175-.323-.3-.74-.337-1.208-.086-1.07.304-1.97.87-2.016a.611.611 0 0 1 .262.047L17.71 0 2.9 5.334c.252.7.537 1.392.897 2.07 1.915 3.6 5.034 6.136 8.593 7.414 0 0 1.078.445 1.564.186l1.592-6.354h-.002zm-.493-3.142a1.106 1.106 0 1 1-1.19-1.015c.61-.05 1.143.406 1.19 1.015zM7.45 6.59a1.58 1.58 0 1 1 3.147-.251 1.58 1.58 0 0 1-3.146.251H7.45zm2.95 3.655a1.028 1.028 0 1 1 2.048-.164 1.03 1.03 0 1 1-2.05.165l.002-.001z" />
    <path d="M4.62 13.09C1.285 9.757.383 6.226.326 5.994l1.844-.45-.92.225.92-.227c.08.325 2.084 7.97 11.638 10.668l-.517 1.827c-3.934-1.11-6.72-2.994-8.67-4.947H4.62z" />
  </svg>
)

export default SliceIcon



// WEBPACK FOOTER //
// ./src/components/sliceIcon.js